import React, { FC } from 'react';
import * as Styled from './TicketDevice.styles';
import * as O from 'fp-ts/Option';
import * as TE from 'fp-ts/TaskEither';
import * as TicketService from '@modules/ticket/service';
import { pipe } from 'fp-ts/function';
import { useTranslations } from '@shared/modules/translation/hooks';
import { useSendTask } from '@core/http/hooks';
import { CheckSerialParams } from '@modules/ticket/model';
import TicketDeviceForm from '@modules/ticket/components/device/TicketDeviceForm';

interface TicketDeviceProps {
  serials: Array<string>;
  setSerialId: (serialId: O.Option<string>) => void;
}

const TicketDevice: FC<TicketDeviceProps> = ({ serials, setSerialId }) => {
  const translations = useTranslations();

  const [loading, check, error] = useSendTask(TicketService.checkSerial);

  const handleSubmit = (params: CheckSerialParams) => {
    pipe(
      () => check(params.equipmentSerialId),
      TE.chainFirstIOK(() => () => setSerialId(O.some(params.equipmentSerialId))),
    )();
  };

  const options = serials.map(serial => ({ value: serial, label: serial }));

  return (
    <Styled.TicketDeviceContainer>
      <Styled.TicketDeviceTitle>{translations.tickets.subtitle}</Styled.TicketDeviceTitle>

      <TicketDeviceForm loading={loading} error={error} onSubmit={handleSubmit} options={options} />
    </Styled.TicketDeviceContainer>
  );
};

export default TicketDevice;
